/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';

import Localized from '../../../../shared/components/Localized';

import styles from '../../../styles';

const Wrapper = styled.div`
  padding: 2rem;
  ${styles.fonts.headingMedium}
`;
const Form = () => (
  <Wrapper>
    <Localized modelKey='loginFailed' modelAttribute='label' modelName='login' />
  </Wrapper>
);

export default Form;
